module.exports = __webpack_public_path__ + "static/film1-200b930d8df8d566de41a7dea7738504.jpg";